import {useGetAndSet} from "./useGetAndSet";
import {createSetMovementsDataAction} from "../actions/dataActions";


export const useMovementsData = (params, dataFresh) => {
    return useGetAndSet("movement", params, createSetMovementsDataAction, dataFresh);
}